import React from 'react';

import {
  SUBSCRIPTION_PLANS_CONFIG,
  SubscriptionPlan,
} from '@/components/SubscriptionCard/SubscriptionCard.utils';
import { SubscriptionCardContent } from '@/components/SubscriptionCard/SubscriptionCardContent/SubscriptionCardContent';
import { SubscriptionCardHeader } from '@/components/SubscriptionCard/SubscriptionCardHeader';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';
import useMediaQuery from '@/Utils/useMediaQuery';

type Props = {
  plan: SubscriptionPlan;
};

export const SubscriptionCard = ({ plan }: Props) => {
  const planConfig = SUBSCRIPTION_PLANS_CONFIG[plan];
  const id = planConfig.id;
  const cardBgColor = plan === 'Free' ? 'bg-freePlan' : planConfig.accentColor;

  const { data: user } = useCurrentUser();
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (!user) return null;

  const isCurrentPlan = user.subscription?.plan_name
    ? plan === user.subscription?.plan_name
    : plan === 'Free';

  return (
    <div
      className={`shadow-membershipCard rounded-lg m-5 ${cardBgColor}`}
      style={{ minWidth: '320px', maxWidth: isMobile ? '100%' : '320px' }}
    >
      <SubscriptionCardHeader
        plan={plan}
        isCurrentPlan={isCurrentPlan}
        iconSrc={planConfig.iconSrc}
        accentColor={planConfig.accentColor}
        isMostPopular={planConfig.isMostPopular}
      />
      <SubscriptionCardContent
        plan={plan}
        isCurrentPlan={isCurrentPlan}
        id={id}
      />
    </div>
  );
};
